/**
 * Password validation error messages mapping.
 */
export const PASSWORD_ERROR_MESSAGES: Record<string, string> = {
  length: "Password must be at least 8 characters long.",
  uppercase: "Password must contain at least one uppercase letter.",
  lowercase: "Password must contain at least one lowercase letter.",
  digit: "Password must contain at least one digit.",
  special: "Password must contain at least one special character.",
};

/**
 * Validates password fields and returns error messages.
 * @param oldPassword - The old password
 * @param newPassword - The new password
 * @param confirmPassword - The password confirmation
 * @returns Object with error messages for newPassword and confirmPassword fields
 */
export const validatePasswordChange = (
  oldPassword: string | undefined,
  newPassword: string | undefined,
  confirmPassword: string | undefined
): { newPassword: string; confirmPassword: string } => {
  const errors = { newPassword: "", confirmPassword: "" };

  if (!newPassword || !confirmPassword) {
    errors.newPassword = newPassword ? "" : "Password is required";
    errors.confirmPassword = confirmPassword
      ? ""
      : "Please confirm your password";
    return errors;
  }

  if (newPassword !== confirmPassword) {
    errors.confirmPassword = "Passwords do not match";
    return errors;
  }

  if (oldPassword && oldPassword === newPassword) {
    errors.newPassword = "New password cannot be the same as old password";
    return errors;
  }

  return errors;
};
